import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { HeaderBaseProps } from '../types';

export const HeaderBody = ({ css, children }: HeaderBaseProps) => {
  return (
    <Text
      css={[
        {
          display: 'flex',
          flexDirection: 'column',
          color: `${theme.colors.neutral50}`,
          fontSize: `${theme.fontSize(16)}`,
          lineHeight: `${theme.spacing(2.75)}`,
          gap: `${theme.spacing(0.5)}`,
          marginTop: `${theme.spacing(1)}`,
          padding: `${theme.spacing(0, 0.5, 0.5, 0.5)}`,
        },
        css,
      ]}
    >
      {children}
    </Text>
  );
};
